module.exports = __webpack_public_path__ + "img/Accura logo design_Web_blue.fc723c77.svg";